module.exports = __webpack_public_path__ + "img/result_txt.7520f9cb.png";